module.exports = __webpack_public_path__ + "static/media/dom7_1.9e1c47c5.jpg";